import React, { Component } from "react";
import { timeFormatter } from "../../services/helper";
import Loader from "../lottie/Loader";
import GenericCarousel from "../generic/GenericCarousel";

export default class OurBlogs extends Component {
  constructor(props) {
    super(props);
    this.state = { isBlogs: false, blogsData: [], activeItemIndex: 0 };
  }
  componentDidUpdate() {
    const { isBlogs } = this.state;
    const { blogs, author, authorImage } = this.props;
    let blogsData = [];
    if (!isBlogs && blogs && blogs.length) {
      blogs.forEach((element, index) => {
        let blog = (
          <div key={index}>
            {authorImage &&
              authorImage.length &&
              authorImage[index].map((imageLink, index) => {
                return (
                  <React.Fragment key={imageLink.id}>
                    {element.featured_media == imageLink.id && (
                      <a href={element.link}>
                        <img
                          style={{ width: "100%", cursor: "pointer" }}
                          src={imageLink.source_url}
                        />
                      </a>
                    )}
                  </React.Fragment>
                );
              })}
            <h4 className="h4 semi-bold text-light-grey m-t-30">
              {element.title.rendered}
            </h4>
            {author &&
              author.length &&
              author.map((data, index) => {
                return (
                  <React.Fragment key={`${data.name} ${data.id}`}>
                    {data.id == element.author && (
                      <h6
                        key={`${data.name} ${data.id}`}
                        className="h6 text-light-grey light m-t-10"
                      >
                        {timeFormatter(element.date) + "|" + " " + data.name}
                      </h6>
                    )}
                  </React.Fragment>
                );
              })}
          </div>
        );
        blogsData.push(blog);
      });
      this.setState({ blogsData, isBlogs: true });
    }
  }

  render() {
    const { blogs, author, authorImage, webBlogsData, isMobile } = this.props;    

    return (
      <section
        className={
          isMobile ? "mob-blog-section p-b-30" : "blog-section p-t-80 p-b-80"
        }
      >
        <div
          id="carousel-container"
          className={isMobile ? "mob-container" : "container"}
        >
          <h2
            className={
              isMobile
                ? "h4 semi-bold text-grey"
                : "h2 semi-bold text-grey m-b-60"
            }
          >
            Our Blogs
          </h2>
          {webBlogsData.isLoading ? (
            <Loader />
          ) : (
            <div className={isMobile ? "mob-blog-card" : ""}>
              {blogs && blogs.length && (
                <GenericCarousel
                  dots={false}
                  marginLeft={10}
                  fromLandingPage={true}
                  numberOfCards={isMobile ? 1 : 3}
                  isMobile={isMobile}
                >
                  {blogs.map((element, index) => {
                    return (
                      <div key={index}>
                        {authorImage &&
                          authorImage.length &&
                          authorImage[index].map((imageLink, index) => {
                            return (
                              <React.Fragment key={imageLink.id}>
                                {element.featured_media == imageLink.id && (
                                  <a
                                    href={element.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <img
                                      style={{
                                        width: "100%",
                                        cursor: "pointer"
                                      }}
                                      className="lazyload"
                                      src={imageLink.source_url}
                                      alt={element.title.rendered}
                                    />
                                  </a>
                                )}
                              </React.Fragment>
                            );
                          })}
                        <h4 className="h4 semi-bold text-light-grey m-t-30">
                          {element.title.rendered}
                        </h4>
                        {author &&
                          author.length &&
                          author.map((data, index) => {
                            return (
                              <React.Fragment key={`${data.name} ${data.id}`}>
                                {data.id == element.author && (
                                  <h6
                                    key={`${data.name} ${data.id}`}
                                    className="h6 text-light-grey light m-t-10"
                                  >
                                    {timeFormatter(element.date) +
                                      "|" +
                                      " " +
                                      data.name}
                                  </h6>
                                )}
                              </React.Fragment>
                            );
                          })}
                      </div>
                    );
                  })}
                </GenericCarousel>
              )}
            </div>
          )}
        </div>
      </section>
    );
  }
}
